import React, { ReactNode } from "react";
import { useHistory } from "react-router";
import { Button } from "@material-ui/core";

const DividerButton = ({ button, link }): ReactNode => {
  const navigate = useHistory();

  const onButtonClick = () => {
    navigate.push(link);
  };
  return (
    <div className="hr-divider">
      <hr className="horizontal-line" />
      <Button
        style={{ border: "1.5px solid", fontWeight: 700, width: 300 }}
        variant="outlined"
        color="secondary"
        onClick={onButtonClick}
      >
        {button}
      </Button>
      <hr className="horizontal-line" />
    </div>
  );
};

export default DividerButton;
